import React, { useEffect, useState } from "react";
import "./ImageSlider.css";
import { MoreVertical } from "lucide-react";

const images = ["1.png", "2.png", "3.png", "4.png", "5.png", "6.png", "7.png"];

const App = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [email, setEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideDirection, setSlideDirection] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (currentIndex === images.length - 1) {
      setIsDropdownOpen(true);
    } else {
      setIsDropdownOpen(false);
    }
  }, [currentIndex]);

  const handleDropdownItemClick = (action) => {
    if (action === "inquiry") {
      window.location.href = "https://leaddemo.framer.website/form";
    } else if (action === "demo") {
      window.location.href = "tel:+82-10-2533-7519";
    }
    setIsDropdownOpen(false);
  };
  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://submit-form.com/sF8FP3DZ5", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: "Demo User",
          email: email,
          message: "Demo request from LeadDemo",
        }),
      });

      if (response.ok) {
        setIsVerified(true);
      } else {
        alert("제출 중 오류가 발생했습니다. 다시 시도해주세요.");
      }
    } catch (error) {
      alert("제출 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const goToPrevious = () => {
    if (currentIndex === 0) return;
    setSlideDirection("slide-right");
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => prevIndex - 1);
      setIsTransitioning(false);
    }, 300);
  };

  const goToNext = () => {
    if (currentIndex === images.length - 1) return;
    setSlideDirection("slide-left");
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1);
      setIsTransitioning(false);
    }, 300);
  };

  const goToImage = (index) => {
    if (Math.abs(index - currentIndex) > 1) return;
    const direction = index > currentIndex ? "slide-left" : "slide-right";
    setSlideDirection(direction);
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
  };

  if (!isVerified) {
    return (
      <div className="email-form-container">
        <div className="accent-bar"></div>
        <div className="email-form-content">
          <div className="form-header">
            <h2>LeadDemo 데모를 바로 확인하세요! 👋</h2>
            <p>이메일을 입력하면 데모를 바로 확인하실 수 있습니다.</p>
          </div>
          <form onSubmit={handleEmailSubmit} className="email-form">
            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="이메일 주소를 입력하세요"
                required
              />
            </div>
            <button type="submit" className="submit-button">
              시작하기
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="slider-wrapper">
      {currentIndex > 0 && (
        <div className="arrow left" onClick={goToPrevious}>
          &#10094;
        </div>
      )}
      <div className="slider-container">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex + 1}`}
          className={isTransitioning ? slideDirection : ""}
        />
        <div className="dots-container-overlay">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => goToImage(index)}
            ></span>
          ))}
        </div>
        {/* Floating Action Button with Dropdown */}
        <div className="floating-action-button-container">
          <button
            className="floating-action-button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <MoreVertical className="w-6 h-6" />
          </button>

          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-header">전문가와 상담해보세요!</div>
              <button
                className="dropdown-item"
                onClick={() => handleDropdownItemClick("inquiry")}
              >
                도입 문의하기
              </button>
              <button
                className="dropdown-item"
                onClick={() => handleDropdownItemClick("demo")}
              >
                전화 상담하기
              </button>
              <div className="dropdown-footer">powered by leaddemo</div>
            </div>
          )}
        </div>
      </div>

      {currentIndex < images.length - 1 && (
        <div className="arrow right" onClick={goToNext}>
          &#10095;
        </div>
      )}
    </div>
  );
};

export default App;
